import { urlEndPoint } from "helpers/GeneralHelper";

/**
 * Raw sidebar menu definition (matches previous SidebarContent MENU_CONFIG).
 */
export function createMenuConfig(permissionData) {
  return [
    {
      title: "Main",
      key: "main",
      icon: "fa fa-home",
      permission: permissionData?.HomeAccess || permissionData?.TaskPlannerMenuAccess || false,
      items: [
        {
          name: "Dashboard",
          icon: "fa fa-home",
          routeLink: "dashboard",
          permission: permissionData?.HomeAccess || false,
          menu: true,
        },
        {
          name: "AI Dashboard",
          icon: "fa fa-robot",
          routeLink: "ai-dashboard",
          permission: permissionData?.AIPipelineDashboardAccess || false,
          menu: true,
        },
        {
          name: "Task Planner",
          icon: "fa fa-tasks",
          routeLink: "task-planner",
          permission: permissionData?.TaskPlannerMenuAccess || false,
          menu: true,
        },
        {
          name: "Client Journey",
          icon: "fa fa-object-ungroup",
          routeLink: "client-journey",
          permission: permissionData?.TaskPlannerMenuAccess || false,
          menu: true,
        },
        {
          name: "Internal Task Planner",
          icon: "fa fa-tasks",
          routeLink: "internal-task-planner",
          permission: permissionData?.TaskPlannerInternalMenuAccess || false,
          menu: true,
        },
      ],
    },
    {
      icon: "fa fa-lock",
      title: "Master Data",
      key: "master",
      permission: permissionData?.MasterAccess || false,
      items: [
        {
          name: "Job Category",
          routeLink: "job-category",
          permission: permissionData?.JobCategoryAccess || false,
          menu: true,
        },
        {
          name: "Job Require",
          routeLink: "job-required",
          permission: permissionData?.JobRequireAccess || false,
          menu: true,
        },
        {
          name: "Question Type",
          routeLink: "question-type",
          permission: permissionData?.QuestionTypeAccess || false,
          menu: true,
        },
        {
          name: "Register Field",
          routeLink: "register-field",
          permission: permissionData?.RegisterFieldAccess || false,
          menu: true,
        },
        { name: "Job", routeLink: "jobs", permission: permissionData?.JobAccess || false, menu: true },
        { name: "FADV Api Package", routeLink: "ai-fadv-package", permission: permissionData?.MasterFadvApiPackageAccess || false, menu: true },
        { name: "Client Plan", routeLink: "client-plan", permission: permissionData?.MasterClientPlanAccess || false, menu: true },
        {
          name: "Source",
          routeLink: "source",
          permission: permissionData?.SourceAccess || false,
          menu: true,
        },
        { name: "Reasons", routeLink: "reasons", permission: permissionData?.MasterReasonsAccess || false, menu: true },
        { name: "Doc Required", routeLink: "doc-required", permission: permissionData?.DocumentRequiredAccess || false, menu: true },
        { name: "Onboarding Doc.", routeLink: "onboarding-documents", permission: permissionData?.OnboardingDocumentsAccess || false, menu: true },
        { name: "Task Bucket", routeLink: "task-bucket", permission: permissionData?.MasterTaskBucketAccess || false, menu: true },
        { name: "Task Group Settings", routeLink: "task-group-settings", permission: permissionData?.MasterTaskBucketAccess || false, menu: true },
        { name: "Legends", routeLink: "legends", permission: permissionData?.MasterLegends || false, menu: true },
        {
          name: "Auditing Parameter",
          routeLink: "auditing-parameter",
          permission: permissionData?.MasterAuditingParameters || false,
          menu: true,
        },
        {
          name: "Auditing Template",
          routeLink: "auditing-templates",
          permission: permissionData?.AuditingTemplateAddAccess || false,
          menu: true,
        },
        {
          name: "Twilio Phone Number",
          routeLink: "twilio-phone",
          permission: permissionData?.TwilioPhoneNumberAccess || false,
          menu: true,
        },
        {
          name: "AI Schedule Matrix Group",
          routeLink: "ai-schedule-matrix-group",
          permission: permissionData?.AIScheduleMatrixAccess || false,
          menu: true,
        },
        {
          name: "Bad Fit Resolution Reason",
          routeLink: "bad-fit-resolution-reason",
          permission: permissionData?.MasterBadFitResolutionReasonAccess || false,
          menu: true,
        },
      ],
    },
    {
      icon: "fa fa-users",
      title: "Client",
      key: "client",
      permission: permissionData?.ClientMenuAccess || false,
      items: [
        { name: "Company", routeLink: "company", permission: permissionData?.ClientCompanyAccess || false, menu: true },
        {
          name: "Register",
          routeLink: "client-register",
          permission: permissionData?.RegisterAccess || false,
          menu: true,
        },
        { name: "Client", routeLink: "client", permission: permissionData?.ClientListAccess || false, menu: true },
        { name: "Source", routeLink: "client/source", permission: permissionData?.ClientSourceAccess || false, menu: true },
        {
          name: "Client Review",
          routeLink: "client/review",
          permission: permissionData?.ClientReviewViewAccess || false,
          menu: true,
        },
        {
          name: "Pre Questioning",
          routeLink: "pre-questioning",
          permission: permissionData?.ClientPreQuestioningAccess || false,
          menu: true,
        },
        {
          name: "Job Description",
          routeLink: "job-description",
          permission: permissionData?.ClientJobDescViewAcces || false,
          menu: true,
        },
        {
          name: "Client Appreciation",
          routeLink: "client-appreciation",
          permission: permissionData?.ClientAppreciationViewAcces || false,
          menu: true,
        },
        {
          name: "Onboarding List",
          routeLink: "onboarding-list",
          permission: permissionData?.OnboardingAccess || false,
          menu: true,
        },
        {
          name: "Offboarding List",
          routeLink: "offboarding-list",
          permission: permissionData?.OffboardingAccess || false,
          menu: true,
        },
      ],
    },
    {
      icon: "fa fa-user-plus",
      title: "Candidate",
      key: "candidate",
      permission: permissionData?.CandidateMenuAccess || false,
      items: [
        // { name: "Call Details", routeLink: "call-details", permission: true, menu: true },
        {
          name: "New Candidate",
          routeLink: "new-candidate",
          permission: permissionData?.CandidateAddAccess || false,
          menu: true,
        },
        {
          name: "Candidate",
          routeLink: "candidates",
          permission: permissionData?.CandidateAccess || permissionData?.CandidateAccess_two || false,
          menu: true,
        },
        {
          name: "Hire Status",
          routeLink: "candidate-hire-status",
          permission: permissionData?.CandidateHireStatusAccess || false,
          menu: true,
        },
        {
          name: "Verify Test",
          routeLink: "verify-test",
          permission: permissionData?.CandidateVerifyTestAccess || false,
          menu: true,
        },
        {
          name: "Call Back Request",
          routeLink: "candidate-call-back-request",
          permission: permissionData?.CandidateCallBackRequest || false,
          menu: true,
        },
        {
          name: "Upload Profile CSV",
          routeLink: "upload-profile-csv",
          permission: permissionData?.CandidateUploadProfileCsvAccess || false,
          menu: true,
        },
        {
          name: "Upload Drug CSV",
          routeLink: "upload-drug-csv",
          permission: permissionData?.CandidateUploadDrugCsvAccess || false,
          menu: true,
        },
        // {
        //   name: "Upload Bulk CV",
        //   routeLink: "upload-bulk-cv",
        //   permission: permissionData?.CandidateUploadBulkCVAccess || false,
        //   menu: true,
        // },
        {
          name: "FADV CSV Log",
          routeLink: "fadv-csv-log",
          permission: permissionData?.CandidateFadvCsvLogRequest || false,
          menu: true,
        },
        {
          name: "FADV Order Log",
          routeLink: "fadv-order-log",
          permission: permissionData?.CandidateFadvOrderLog || false,
          menu: true,
        },
        {
          name: "FADV Profile Order Log",
          routeLink: "fadv-profile-order-log",
          permission: permissionData?.CandidateFadvProfileOrderLog || false,
          menu: true,
        },
        {
          name: "Verify FADV CSV",
          routeLink: "verify-fadv-csv",
          permission: permissionData?.CandidateVerifyFADVCsvAccess || false,
          menu: true,
        },
        {
          name: "Modify Closure",
          routeLink: "modify-closure",
          permission: permissionData?.CandidateModifyClosureAccess || false,
          menu: true,
        },
        {
          name: "Block FADV Requestor",
          routeLink: "block-fadv-requestor",
          permission: permissionData?.CandidateBlockFadvRequestorAccess || false,
          menu: true,
        },
        {
          name: "TSA PreCheck",
          routeLink: "tsa-check",
          permission: permissionData?.CandidateOnboardingListAccess || false,
          menu: true,
        },
        {
          name: "Verify Application File",
          routeLink: "verify-application-file",
          permission: permissionData?.CandidateVerifyApplicationFileAccess || false,
          menu: true,
        },
        {
          name: "Bad Fit",
          routeLink: "bad-fit",
          permission: permissionData?.BadFitResolutionAccess || false,
          menu: true,
        },
        {
          name: "External Leads",
          routeLink: "external-leads",
          permission: permissionData?.ExternalLeadsAccess || false,
          menu: true,
        },
      ],
    },
    {
      icon: "fa fa-phone",
      title: "Call",
      key: "call-log",
      permission: permissionData?.CallMenuAccess || permissionData?.CallExcutiveMenuAccess || false,
      items: [
        { name: "Schedule", routeLink: "schedule", permission: permissionData?.CallExcuSechuledAccess || false, menu: true },
        { name: "Not On AI", routeLink: "not-on-ai", permission: permissionData?.CallExecutiveAccess || false, menu: true },
        { name: "Today", routeLink: "today", permission: permissionData?.CallExcuTodayAccess || false, menu: true },
        // { name: "Interview", routeLink: "interview", permission: true, menu: true },
        { name: "Wrong Number", routeLink: "wrong-number", permission: permissionData?.CallExcuVMAccess || false, menu: true },
        { name: "Under Age", routeLink: "under-age", permission: permissionData?.CallExecutiveAccess || false, menu: true },
        { name: "My Call", routeLink: "my-call", permission: permissionData?.CallMyCall || permissionData?.MyCallAccess || false, menu: true },
        { name: "Deactivate Candidate", routeLink: "deactivate-candidate", permission: permissionData?.CallDeactiveCandidate || false, menu: true },
        { name: "In Progress", routeLink: "order-in-progress", permission: permissionData?.CallMgrOIPAccess || false, menu: true },
        { name: "Ready to send update", routeLink: "ready-to-send-update", permission: permissionData?.CallMgrResolvedAccess || false, menu: true },
        { name: "Further Review", routeLink: "further-review", permission: permissionData?.CallMgrFRAccess || false, menu: true },
        { name: "RTR Acknowledgement", routeLink: "rtr-acknowledgement", permission: permissionData?.CallRTRAcknowledgeAccess || false, menu: true },
      ],
    },
    {
      icon: "fa fa-book",
      title: "Report",
      key: "report",
      permission: permissionData?.ReportMenuAccess || false,
      items: [
        {
          name: "In Progress Report",
          routeLink: "inprogress-report",
          permission: permissionData?.ReportInProgressAccess || false,
          menu: true,
        },
        {
          name: "RTR Internal Report",
          routeLink: "rtr-internal-report",
          permission: permissionData?.ReportRTRInternalAccess || false,
          menu: true,
        },
        {
          name: "Client Report",
          routeLink: "client-report",
          permission: permissionData?.ReportClientAccess || false,
          menu: true,
        },
        {
          name: "Candidate Summary Report",
          routeLink: "candidate-summary-report",
          permission: permissionData?.ReportCandidateSummaryAccess || false,
          menu: true,
        },
        {
          name: "Eligible Report",
          routeLink: "eligible-report",
          permission: permissionData?.ReportEligibleAccess || false,
          menu: true,
        },
        {
          name: "Closure Report",
          routeLink: "closure-report",
          permission: permissionData?.ReportClosureAccess || false,
          menu: true,
        },
        {
          name: "Client User Report",
          routeLink: "client-user-report",
          permission: permissionData?.ReportUserAccess || false,
          menu: true,
        },
        {
          name: "Ready To Send Report",
          routeLink: "ready-to-send-report",
          permission:
            permissionData?.ReportReadyToSendAccess ||
            permissionData?.ReportReadyToSendClientAccess ||
            false,
          menu: true,
        },
        // {
        //   name: "Compliance Report",
        //   routeLink: "compliancy-report",
        //   permission: permissionData?.ReportComplianceAccess || false,
        //   menu: true,
        // },
        {
          name: "Drug CSV Activity Report",
          routeLink: "drug-csv-upload-report",
          permission: permissionData?.ReportDrugCSVActivityAccess || false,
          menu: true,
        },
        {
          name: "User Client Activity Report",
          routeLink: "user-client-activity-report",
          permission: permissionData?.ReportUserClientActivityAccess || false,
          menu: true,
        },
        {
          name: "Session Activity Report",
          routeLink: "session-activity-report",
          permission: permissionData?.ReportSessionActivityAccess || false,
          menu: true,
        },
        {
          name: "Leads Added Report",
          routeLink: "leads-added-report",
          permission: permissionData?.ReportLeadsAddedAccess || false,
          menu: true,
        },
        {
          name: "Client Status Report",
          routeLink: "client-status-report",
          permission: permissionData?.ReportClientStatusAccess || false,
          menu: true,
        },
        {
          name: "Team Performance Report",
          routeLink: "team-performance-report",
          permission: permissionData?.ReportTeamPerformanceAccess || false,
          menu: true,
        },
        {
          name: "Backend Performance Report",
          routeLink: "backend-performance-report",
          permission: permissionData?.ReportBackEndPerformanceAccess || false,
          menu: true,
        },
        {
          name: "Segment Completion Report",
          routeLink: "segment-completion-report",
          permission: permissionData?.SegmentCompletionReportAccess || false,
          menu: true,
        },
        {
          name: "Not Interested Report",
          routeLink: "not-interested-report",
          permission: permissionData?.NotInterstedReportAccess || false,
          menu: true,
        },
        {
          name: "Month Wise Summary Report",
          routeLink: "month-wise-summary-report",
          permission: permissionData?.ReportMonthSummaryAccess || false,
          menu: true,
        },
        {
          name: "SME Performance Report",
          routeLink: "sme-performance-report",
          permission: permissionData?.SMEPerformanceReportAccess || false,
          menu: true,
        },
        {
          name: "Caller Performance Report",
          routeLink: "caller-performance-report",
          permission: permissionData?.CallerPerformanceReportAccess || false,
          menu: true,
        },
        {
          name: "AI FADV Report",
          routeLink: "ai-fadv-report",
          permission: permissionData?.ReportAIFadvUserWiseClientAccess || false,
          menu: true,
        },
        
      ],
    },
    {
      icon: "fas fa-money-bill-alt",
      title: "Incentive",
      key: "incentive",
      permission: permissionData?.IncentiveMenuAccess || false,
      items: [
        // { name: "Achievements", routeLink: "achievements", permission: permissionData?.IncentiveAchievementsAccess || false, menu: true },
        // { name: "Monthly List", routeLink: "monthly-list", permission: permissionData?.IncentiveMonthlyListAccess || false, menu: true },
        { name: "Achievements Three", routeLink: "achievements-three", permission: permissionData?.IncentiveAchievementsAccess || false, menu: true },
        { name: "Monthly List Three", routeLink: "monthly-list-three", permission: permissionData?.IncentiveMonthlyListAccess || false, menu: true },
      ],
    },
    {
      icon: "fa fa-handshake",
      title: "Team Recognition",
      key: "team-recognition",
      permission: permissionData?.TeamRecognitionMenuAccess || false,
      items: [
        {
          name: "Achievements",
          routeLink: `${urlEndPoint.teamRecognitionAchievements}`,
          permission: permissionData?.TeamRecognitionAchievementsAccess || false,
          menu: true,
        },
        {
          name: "Monthly List",
          routeLink: `${urlEndPoint.teamRecognitionMonthlyList}`,
          permission: permissionData?.TeamRecognitionMonthlyListAccess || false,
          menu: true,
        },
      ],
    },
    {
      icon: "fa fa-phone",
      title: "Audit",
      key: "audit",
      permission:
        permissionData?.AuditMenuAccess ||
        permissionData?.CallAuditAccess ||
        permissionData?.CallAuditCreateAccess ||
        false,
      items: [
        {
          name: "Call Audit",
          routeLink: `${urlEndPoint.callAudit}`,
          permission: permissionData?.CallAuditAccess || permissionData?.AuditMenuAccess || false,
          menu: true,
        },
        {
          name: "Create Audit",
          action: "createAudit",
          permission: permissionData?.CallAuditCreateAccess || false,
          menu: true,
        },
        // {
        //   name: "Monthly List",
        //   routeLink: `${urlEndPoint.teamRecognitionMonthlyList}`,
        //   permission: true,
        //   menu: true,
        // },
      ],
    },
    {
      icon: "fa fa-cog",
      title: "Settings",
      key: "settings",
      permission:
        permissionData?.SettingAccess ||
        permissionData?.MailTemplateAccess ||
        permissionData?.ConversationTemplateAccess ||
        permissionData?.UserIPSettingsAccess ||
        permissionData?.NotificationSettingAccess ||
        permissionData?.OverrideMasterSettings ||
        permissionData?.TestEmailAccess ||
        false,
      items: [
        {
          name: "Mail Template",
          routeLink: `${urlEndPoint.mailTemplate}`,
          permission: permissionData?.MailTemplateAccess || false,
          menu: true,
        },
        {
          name: "Conversation Template",
          routeLink: `${urlEndPoint.conversationTemplate}`,
          permission: permissionData?.ConversationTemplateAccess || false,
          menu: true,
        },
        {
          name: "User IP Settings",
          routeLink: `${urlEndPoint.userIpSettings}`,
          permission: permissionData?.UserIPSettingsAccess || false,
          menu: true,
        },
        {
          name: "Override Master Settings",
          action: "overrideMasterSettings",
          permission: permissionData?.OverrideMasterSettings || false,
          menu: true,
        },
        {
          name: "Notification Settings",
          routeLink: `${urlEndPoint.notificationSetting}`,
          permission: permissionData?.NotificationSettingAccess || false,
          menu: true,
        },
        {
          name: "Test Email Server",
          action: "testEmailServer",
          permission: permissionData?.TestEmailAccess || false,
          menu: true,
        },
        {
          name: "AI SMS Template",
          routeLink: `${urlEndPoint.AISmsSetting}`,
          permission: permissionData?.AISmsTemplateAccess || false,
          menu: true,
        },
        {
          name: "AI Add On Call Template",
          routeLink: `${urlEndPoint.AIAddonCallTemplateSetting}`,
          permission: permissionData?.AIAddonCallTemplateAccess || false,
          menu: true,
        },
        { name: "AI Schedule Matrix", routeLink: `${urlEndPoint.aiScheduleMatrix}`, permission: permissionData?.AIScheduleMatrixAccess || false, menu: true },
        {
          name: "Conversation Matrix",
          routeLink: `${urlEndPoint.conversationMatrix}`,
          permission:
            permissionData?.ConversationScheduleMatrixAccess ||
            false,
          menu: true,
        },

        // {
        //   name: "Monthly List",
        //   routeLink: `${urlEndPoint.teamRecognitionMonthlyList}`,
        //   permission: true,
        //   menu: true,
        // },
      ],
    },
    {
      icon: "fa fa-users",
      title: "User & Team",
      key: "team",
      permission:
        permissionData?.TeamAccess ||
        permissionData?.UserWorkShiftAccess ||
        permissionData?.UserWarningLetterAccess ||
        permissionData?.UserTypeAccess ||
        permissionData?.UserAccess ||
        permissionData?.UserActivityListAccess ||
        permissionData?.UserAttendanceAccess ||
        false,
      items: [
        { name: "Team", routeLink: "team", permission: permissionData?.TeamAccess || false, menu: true },
        { name: "Work Shift", routeLink: "work-shift", permission: permissionData?.UserWorkShiftAccess || false, menu: true },
        {
          name: "Warning Letter",
          routeLink: "warning-letter",
          permission: permissionData?.UserWarningLetterAccess || false,
          menu: true,
        },
        {
          name: "User Type",
          routeLink: "user-type",
          permission: permissionData?.UserTypeAccess || false,
          menu: true,
        },
        {
          name: "User",
          routeLink: "manage-user",
          permission: permissionData?.UserAccess || false,
          menu: true,
        },
        {
          name: "Activity",
          routeLink: `${urlEndPoint.userActivities}`,
          permission: permissionData?.UserActivityListAccess || false,
          menu: true,
        },
        {
          name: "Attendance",
          routeLink: `${urlEndPoint.attendanceReport}`,
          permission: permissionData?.UserAttendanceAccess || false,
          menu: true,
        },
      ],
    },
    {
      icon: "fa fa-microchip",
      title: "AI Recruiter",
      key: "ai-recruiter",
      permission:
        permissionData?.AIRecruiterMenuAccess ||
        permissionData?.AIRecruiterAccess || permissionData?.ClientMoveToAIRecruiterAccess ||
        false,
      items: [
        {
          name: "AI Recruiter Log",
          routeLink: "ai-recruiter-log",
          permission:
            permissionData?.AIRecruiterLogAccess ||
            permissionData?.AIRecruiterAccess ||
            false,
          menu: true,
        },
        {
          name: "Call Scheduled Report",
          routeLink: "call-scheduled-report",
          permission:
            permissionData?.CallScheduledReportAccess ||
            permissionData?.AIRecruiterAccess ||
            false,
          menu: true,
        },
        {
          name: "AI Recruiter Clients",
          routeLink: "ai-recruiter-client",
          permission:
            permissionData?.ClientMoveToAIRecruiterAccess ||
            false,
          menu: true,
        },
      ],
    },
  ];
}

export function filterMenuGroups(menuConfig) {
  return menuConfig
    .filter((group) => group.permission)
    .map((group) => {
      const items = group.items
        ?.map((item) => {
          if (item.children) {
            const children = item.children.filter((child) => child.permission);
            return children.length ? { ...item, children } : null;
          }
          return item.permission ? item : null;
        })
        .filter(Boolean);

      return items?.length ? { ...group, items } : null;
    })
    .filter(Boolean);
}

export const normalizeMenuRoutePath = (routePath = "") =>
  String(routePath || "")
    .trim()
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");

/** Menu routeLink -> permission flag (for route guards). */
export function flattenMenuRoutesWithPermission(menuConfig) {
  const map = new Map();

  const addRoute = (routeLink, permission) => {
    const key = normalizeMenuRoutePath(routeLink);
    if (!key) return;
    map.set(key, Boolean(permission));
  };

  const walkItems = (items) => {
    for (const item of items || []) {
      if (item.children?.length) {
        walkItems(item.children);
      }
      if (item.routeLink) {
        addRoute(item.routeLink, item.permission);
      }
    }
  };

  for (const group of menuConfig || []) {
    walkItems(group.items);
  }

  return map;
}

const ROUTE_GUARD_BYPASS = new Set(["no-permission", "access-denied"]);

/**
 * @returns {{ guarded: boolean, allowed: boolean }}
 * guarded=false means route is not in sidebar menu config (allow).
 */
export function resolveRoutePermission(routePath, routePermissionMap) {
  const normalized = normalizeMenuRoutePath(routePath);
  if (!normalized || ROUTE_GUARD_BYPASS.has(normalized)) {
    return { guarded: false, allowed: true };
  }

  if (!routePermissionMap?.size) {
    return { guarded: false, allowed: true };
  }

  if (routePermissionMap.has(normalized)) {
    return { guarded: true, allowed: Boolean(routePermissionMap.get(normalized)) };
  }

  let matchedKey = null;
  let matchedLen = 0;
  for (const key of routePermissionMap.keys()) {
    if (normalized === key || normalized.startsWith(`${key}/`)) {
      if (key.length > matchedLen) {
        matchedLen = key.length;
        matchedKey = key;
      }
    }
  }

  if (matchedKey) {
    return {
      guarded: true,
      allowed: Boolean(routePermissionMap.get(matchedKey)),
    };
  }

  const baseKey = normalized.split("/")[0];
  if (routePermissionMap.has(baseKey)) {
    return {
      guarded: true,
      allowed: Boolean(routePermissionMap.get(baseKey)),
    };
  }

  return { guarded: false, allowed: true };
}
